import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyDecimal]'
})
export class OnlyDecimalDirective {
  // Allows: up to 8 digits . 1 digit . 1 digit (partial format allowed)
  private partialTypingRegex = /^\d{0,8}(\.\d{0,1}(\.\d{0,1})?)?$/;
  private exactFormatRegex = /^\d{8}\.\d{1}\.\d{1}$/;

  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const input = event.target.value;

    // Remove all invalid characters (keep only digits and dots)
    const sanitized = input.replace(/[^0-9.]/g, '');

    if (sanitized !== input) {
      // If invalid chars were removed, update the field
      this.control.control?.setValue(sanitized, { emitEvent: false });
    }

    // If empty, clear errors
    if (sanitized === '') {
      this.control.control?.setErrors(null);
      return;
    }

    // Validate against format
    if (this.partialTypingRegex.test(sanitized)) {
      if (this.exactFormatRegex.test(sanitized)) {
        this.control.control?.setErrors(null);
      } else {
        this.control.control?.setErrors({ pattern: true });
      }
    } else {
      // Still show value, just mark as invalid
      this.control.control?.setErrors({ pattern: true });
    }
  }
}
